var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-page',{attrs:{"name":_vm.classTypeName,"plural":_vm.classTypeNamePlural,"use":"_id","display":_vm.display,"page-prefix":"/blade/classes","fetch":_vm.getClasses,"sort-options":_vm.sortOptions,"sort-functions":_vm.sortFunctions,"default-sort":_vm.defaultSort}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-230544fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blade/pages/ClassList.vue
// module id = null
// module chunks = 